import { lazy, Suspense } from 'react';

import { Redirect, Route, Switch } from 'react-router-dom';

import AuthenticatedRoute from 'apps/admin/components/AuthenticatedRoute';

const ProspectListPage = lazy(
  () => import('apps/admin/components/ProspectSurvey/ProspectListContainer'),
);
const ProspectDetailPage = lazy(
  () => import('apps/admin/components/ProspectSurvey/ProspectSurveyDetailPage'),
);

export default function ProspectSurveyRoutes() {
  return (
    <Switch>
      <AuthenticatedRoute exact path="/scouted-location-list">
        <Suspense fallback={null}>
          <ProspectListPage />
        </Suspense>
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path="/scouted-location-survey/new">
        <Suspense fallback={null}>
          <ProspectDetailPage isNew />
        </Suspense>
      </AuthenticatedRoute>
      <AuthenticatedRoute exact path="/scouted-location-survey/:id">
        <Suspense fallback={null}>
          <ProspectDetailPage />
        </Suspense>
      </AuthenticatedRoute>
      <Route
        exact
        path="/prospect-list"
        render={(props) => (
          <Redirect
            to={{
              pathname: '/scouted-location-list',
              search: props.location.search,
              hash: props.location.hash,
            }}
          />
        )}
      />
      <Route
        exact
        path="/prospect-survey"
        render={(props) => (
          <Redirect
            to={{
              pathname: '/scouted-location-list',
              search: props.location.search,
              hash: props.location.hash,
            }}
          />
        )}
      />
      <Route
        exact
        path="/prospect-survey/new"
        render={() => <Redirect to="/scouted-location-survey/new" />}
      />
      <Route
        exact
        path="/prospect-survey/:id"
        render={(props) => <Redirect to={`/scouted-location-survey/${props.match.params.id}`} />}
      />
    </Switch>
  );
}
